/* eslint react/prop-types: 0 */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import FullDetailsAccordion from '../../../components/FullDetailsAccordion';
import TabDetails from '../TabDetails';
import { useFetchFieldData } from '../../../hooks/use-fetch-field-data';
import { formatDate } from '../../../../services/util/formatter';
import { ENTITY_OBJECT_TYPES } from '../../../shared/constants/entity.constants';

import './styles.scss';

/**
 * @param {{
 * accountsList: any
 * layout: any;
 * showLoader: VoidFunction;
 * }} props
 */
const AccountTab = ({ accountsList, layout, showLoader }) => {
  const { id: tabId } = useParams();
  const [selectedId, setSelectedId] = useState('');
  const {
    entityCards: fieldsData,
    selectEntity,
    setEntityLayout,
    updateEntityValues
  } = useFetchFieldData(tabId);

  useEffect(() => {
    setEntityLayout(layout);
  }, [layout, setEntityLayout]);

  const selectCallback = (id) => {
    selectEntity(id);
    setSelectedId(id);
  };

  if (!Array.isArray(accountsList)) {
    return;
  }

  return accountsList.filter(Boolean).map((item, idx) => (
    <FullDetailsAccordion
      key={idx}
      detailsComponent={
        <TabDetails
          fieldsData={fieldsData}
          tabId={tabId}
          selectedId={item.id}
          showLoader={showLoader}
          objectType={ENTITY_OBJECT_TYPES.ACCOUNT}
          onValuesSaved={updateEntityValues}
        />
      }
      selectCallback={selectCallback}
      expanded={selectedId === item.id}
      {...item}
    >
      <>
        <span className="title">
          {item.name} (Expires: {formatDate(item.expires_at)})
        </span>
      </>
    </FullDetailsAccordion>
  ));
};

export default AccountTab;
